// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-action-button[data-v-4e39e90c] i {\n  margin-right: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
